import {
  GET_WAREHOUSEOCCUPANCY_REQUEST,
  GET_WAREHOUSEOCCUPANCY_SUCCESS,
  GET_WAREHOUSEOCCUPANCY_FAILURE,
  DOWNLOAD_WAREHOUSEOCCUPANCY_REQUEST,
  DOWNLOAD_WAREHOUSEOCCUPANCY_SUCCESS,
  DOWNLOAD_WAREHOUSEOCCUPANCY_FAILURE,
} from "./warehouseOccupancyTypes";
import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;

let baseUrlReport = Config.baseUrlReport;

const getWarehouseOccupancyRequest = () => {
  return {
    type: GET_WAREHOUSEOCCUPANCY_REQUEST,
  };
};

const getWarehouseOccupancySuccess = (payload) => {
  return {
    type: GET_WAREHOUSEOCCUPANCY_SUCCESS,
    payload: payload,
  };
};

const getWarehouseOccupancyFailure = (error) => {
  return {
    type: GET_WAREHOUSEOCCUPANCY_FAILURE,
    payload: error,
  };
};

const getWarehouseOccupancy = (
  pageNo,
  rowsPerPage,
  search,
  locationCode,
  warehousesCodesx,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseOccupancyRequest());
    let url = `${baseUrlReport}/warehouse_occupancy?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&locationCode=${locationCode}&warehouseCode=${warehousesCodesx}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehouseOccupancySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseOccupancyFailure(err.message));
      });
  };
};

const getWarehouseOccupancyDownloadRequest = () => {
  return {
    type: DOWNLOAD_WAREHOUSEOCCUPANCY_REQUEST,
  };
};

const getWarehouseOccupancyDownloadSuccess = (payload) => {
  return {
    type: DOWNLOAD_WAREHOUSEOCCUPANCY_SUCCESS,
    payload: payload,
  };
};

const getWarehouseOccupancyDownloadFailure = (error) => {
  return {
    type: DOWNLOAD_WAREHOUSEOCCUPANCY_FAILURE,
    payload: error,
  };
};

const getWarehouseOccupancyDownload = (
  pageNo,
  rowsPerPage,
  search,
  locationCode,
  warehousesCodesx,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseOccupancyDownloadRequest());
    let url = `${baseUrlReport}/warehouse_occupancy?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&locationCode=${locationCode}&warehouseCode=${warehousesCodesx}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehouseOccupancyDownloadSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseOccupancyDownloadFailure(err.message));
      });
  };
};

export { getWarehouseOccupancy, getWarehouseOccupancyDownload };
